export enum AccessEntries {
  DepartmentView = "DepartmentView",
  SingleProjectView = "SingleProjectView",
  TotalProjectOverview = "TotalProjectOverview",
  SyncAllProjects = "SyncAllProjects",
  ImportProject = "ImportProject",
  OpenSettings = "OpenSettings",
  ArchiveProject = "ArchiveProject",
  ProcessProgress = "ProcessProgress",
}

export enum PAGE_ACCESS {
  "None" = "None",
  "Write" = "Write",
  "Read" = "Read",
}

export enum FEATURE_ACCESS {
  "Enabled" = "Enabled",
  "Disabled" = "Disabled",
}

